import { render, staticRenderFns } from "./ShopHospitalVideoTable.vue?vue&type=template&id=12ce7b6d&"
import script from "./ShopHospitalVideoTable.vue?vue&type=script&lang=js&"
export * from "./ShopHospitalVideoTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopHospitalVideoTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports